import { getPaneId } from '../shared';

export default getPaneId('lottie');
